/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import UtilityCostComponent from './UtilityCostComponent/UtilityCostComponent';
import IEnergyManagementProps from '../../DashboardKPIWidgets/IEnergyManagementProps';
import { Card, Icon, Tooltip } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import '../../../scss/KPICardTheme.scss';
import { UtilityCostType } from '../../shared/Utils/Constants';

const UtilityCostWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, bearerToken, requestContext, widgetType } = props;
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const cardHeader =
    widgetType === UtilityCostType.portfolio
      ? t(d.UTILITYCOSTOVERVIEW)
      : t(d.UtilityCost);
  return (
    <DataContextProvider config={connectorConfig}>
      <div className="utility-container kpi-card-common">
        <Card>
          <Card.Header className="kpi-header-container">
            <div style={{ marginRight: '5px' }} className="kpi-card-title">
              {cardHeader}
            </div>
            <Tooltip
              element={<Icon root="common" name="badge-info" size="small" />}
              event="hover"
              header={cardHeader}
              content={t(d.UTILITYBILLTOOLTIPCONTENT)}
              position="right center"
              size="small"
            />
          </Card.Header>
          <Card.Content className="kpi-content-container siteview-progressbar">
            <UtilityCostComponent
              requestContext={requestContext}
              bearerToken={bearerToken}
              widgetType={widgetType}
            />
          </Card.Content>
        </Card>
      </div>
    </DataContextProvider>
  );
};

export default UtilityCostWidget;
